import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisPercentLineChartResponseDto,
  IAnalysisPercentLineChartResultVo,
} from '../types';

import {
  normalizeTableDataList,
  pickAxisChartWireVo,
  pickChartDisplayMeta,
} from './common';

export function transformPercentLineChartResponseDtoToVo(
  dto: IAnalysisPercentLineChartResponseDto,
): IAnalysisPercentLineChartResultVo {
  const {
    percent_line_chart: percentLineChartWire,
    table_data: tableDataWire,
  } = dto;
  const { chartData: percentLineChartData, isNoData } = pickAxisChartWireVo(
    percentLineChartWire,
  );

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.PercentLine,
    isNoData,
    ...(isNoData
      ? {}
      : {
        percentLineChartData,
        tableData: normalizeTableDataList(tableDataWire),
      }),
  };
}
